import { render, staticRenderFns } from "./current-grade.vue?vue&type=template&id=4eaea3a3&"
import script from "./current-grade.vue?vue&type=script&lang=js&"
export * from "./current-grade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports